import { useContext } from 'react';

import ComponentsMapContext from '../../store/context/ComponentsMapContext';

const useComponentsMapContext = () => useContext(ComponentsMapContext);

export default useComponentsMapContext;
